module.exports = __webpack_public_path__ + "img/bg_exploration.4590638e.png";